import { SvgIconProps } from '@mui/material';
import React from 'react';

export default function IcDelete(props: SvgIconProps) {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.6028 5.35791C10.6028 5.35791 10.2506 9.72673 10.0463 11.567C9.94897 12.446 9.40603 12.961 8.5167 12.9772C6.8243 13.0077 5.12997 13.0097 3.43822 12.974C2.58262 12.9565 2.04876 12.435 1.95341 11.5716C1.74778 9.71506 1.39749 5.35791 1.39749 5.35791"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.5001 3.26379H0.499878" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M9.38052 3.26371C8.87131 3.26371 8.43281 2.9037 8.33291 2.40487L8.17528 1.61608C8.07798 1.25217 7.74846 1.00049 7.37287 1.00049H4.62703C4.25145 1.00049 3.92192 1.25217 3.82462 1.61608L3.66699 2.40487C3.5671 2.9037 3.12859 3.26371 2.61938 3.26371"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
